export default {
    methods: {
        formatCurrency(amount) {
            amount = Number(amount);
        
            if(amount < 0) {
                return '-$' + Math.abs(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
    }
};